// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"ac35228d","361":"e3d67acf","525":"da99d569","774":"afc3d09c"}[chunkId] + ".chunk.js";
};